import React, {
  Dispatch, SetStateAction, useEffect, useState,
} from 'react';
import { ACTIVATION_FLOWS, FLOW_STEPS } from '../constants';
import LiliCard from '../../../assets/png/lili-card.png';
import Enroll from './Enroll';
import { useStore } from '../../../store';
import ActivationWithSsn from './ActivationWithSsn';
import ActivateWithExpDate from './ActivateWithExpDate';
import SetPinFlow from './SetPinFlow';
import { getMostRelevantCard } from '../../../helpers/cardStatus.helper';

interface IProps {
  stepsObject: { step: number, setStep: Dispatch<SetStateAction<number>> };
  handleActivatedSuccessfully: () => void;
  openSuccessPopup: () => void;
}
const ActivationRenderSwitch = ({ stepsObject, handleActivatedSuccessfully, openSuccessPopup }: IProps) => {
  const { getPersonalAccount } = useStore(state => state);
  const cardData = getMostRelevantCard(getPersonalAccount().cards);
  const { step, setStep } = stepsObject;
  const { ENROLL, ENTER_DETAILS, SET_PIN } = FLOW_STEPS;
  const { SSN, EXPIRATION_DATE } = ACTIVATION_FLOWS;
  const [activationFlow, setActivationFlow] = useState<string>('');

  useEffect(() => {
    if (cardData) {
      // correct terms
      if (cardData.digital && !cardData.reissueCanBeActivated) {
        if (activationFlow !== SSN) setActivationFlow(SSN);
      } else if (activationFlow !== EXPIRATION_DATE) setActivationFlow(EXPIRATION_DATE);
    }
  }, []);

  switch (step) {
    case ENROLL:
      return <Enroll iconSource={LiliCard} setForward={() => setStep(ENTER_DETAILS)} />;
    case ENTER_DETAILS:
      if (activationFlow === SSN) return <ActivationWithSsn goToStep={(s) => { setStep(s); if (s !== ENROLL) handleActivatedSuccessfully(); }} />;
      if (activationFlow === EXPIRATION_DATE) return <ActivateWithExpDate goToStep={(s) => { setStep(s); if (s !== ENROLL) handleActivatedSuccessfully(); }} />;
      return <div hidden />;
    case SET_PIN:
      return <SetPinFlow setShowSuccessPopup={openSuccessPopup} />;
    default:
      return <div hidden />;
  }
};

export default ActivationRenderSwitch;
